import type { BlogPostRaw } from './types';

const APR = 'https://www.apr.gov.rs/';
const EU_BUS = 'https://europa.eu/youreurope/business/index_en.htm';
const PURS = 'https://www.purs.gov.rs/';
const EUPRAVA = 'https://euprava.gov.rs/';
const NBS = 'https://www.nbs.rs/';
const WIPO = 'https://www.wipo.int/';

export const ALL_BLOG_POSTS_RAW: BlogPostRaw[] = [
  {
    slug: 'virtual-office-belgrade-why-it-matters',
    published: '2026-03-02',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: [
      'business-address-apr-rules',
      'belgrade-prestige-address-brand',
      'virtual-office-roi-costs',
    ],
    externalRefs: [
      { url: APR, label: { sr: 'APR Registar', en: 'APR Business Registers', ru: 'Регистр APR', tr: 'APR sicil', de: 'APR Register' } },
    ],
    translations: {
      sr: {
        title: 'Zašto je virtuelna kancelarija u Beogradu strateški važna',
        metaTitle: 'Virtuelna kancelarija Beograd — zašto je važna za vašu firmu | Top14',
        metaDescription:
          'Virtuelna kancelarija i kancelarija Beograd: poslovna adresa, profesionalni imidž i usklađenost sa APR-om. Vodič za preduzetnike i strane kompanije.',
        excerpt:
          'Kombinacija prestižne lokacije i operativne fleksibilnosti čini virtuelnu kancelariju u Beogradu idealnim rešenjem za ulazak na tržište.',
      },
      en: {
        title: 'Why a virtual office in Belgrade is a strategic advantage',
        metaTitle: 'Virtual Office Belgrade — Why It Matters for Your Company | Top14',
        metaDescription:
          'Virtual office and Belgrade business address: compliance, credibility, and APR alignment. A practical guide for founders and foreign companies.',
        excerpt:
          'A Belgrade virtual office combines a credible address with flexible operations—ideal for entering the Serbian market.',
      },
      ru: {
        title: 'Почему виртуальный офис в Белграде — стратегическое преимущество',
        metaTitle: 'Виртуальный офис Белград — зачем он вашей компании | Top14',
        metaDescription:
          'Виртуальный офис и адрес в Белграде: соответствие требованиям, доверие контрагентов и работа с регистраторами. Практическое руководство.',
        excerpt:
          'Престижный адрес в Белграде и гибкие процессы — удобная база для выхода на рынок Сербии.',
      },
      tr: {
        title: 'Belgrad’da sanal ofis neden stratejik bir avantajdır?',
        metaTitle: 'Belgrad sanal ofis — işletmeniz için neden önemli? | Top14',
        metaDescription:
          'Sanal ofis ve Belgrad iş adresi: uyum, güvenilirlik ve sicil süreçleri. Girişimciler ve yabancı şirketler için pratik rehber.',
        excerpt:
          'Prestijli bir adres ile esnek operasyonu birleştiren yapı, Sırbistan pazarına giriş için güçlü bir temel sunar.',
      },
      de: {
        title: 'Warum ein virtuelles Büro in Belgrad strategisch sinnvoll ist',
        metaTitle: 'Virtuelles Büro Belgrad — warum es für Ihr Unternehmen zählt | Top14',
        metaDescription:
          'Virtuelles Büro und Geschäftsadresse Belgrad: Compliance, Glaubwürdigkeit und APR-Prozesse. Praxisleitfaden für Gründer und internationale Firmen.',
        excerpt:
          'Eine starke Belgrader Adresse plus flexible Abläufe – ideal für den Markteintritt in Serbien.',
      },
    },
  },
  {
    slug: 'opening-company-serbia-checklist',
    published: '2026-03-08',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['apr-registration-timeline-2026', 'business-address-apr-rules', 'foreign-investors-belgrade-hub'],
    externalRefs: [
      { url: APR, label: { sr: 'APR zvanični sajt', en: 'APR official portal', ru: 'Сайт APR', tr: 'APR resmi site', de: 'APR offizielle Seite' } },
      { url: EU_BUS, label: { sr: 'EU poslovni vodič', en: 'EU business guide', ru: 'Гид EU для бизнеса', tr: 'AB iş rehberi', de: 'EU-Unternehmensleitfaden' } },
    ],
    translations: {
      sr: {
        title: 'Otvaranje firme u Srbiji: praktična lista koraka',
        metaTitle: 'Otvaranje firme u Srbiji — koraci, adresa i APR | Top14',
        metaDescription:
          'Otvaranje firme i poslovna adresa u Beogradu: dokumenti, APR, PDV i česti zastojci. Strukturisan pregled za preduzetnike i strane investitore.',
        excerpt:
          'Od izbora pravnog oblika do aktivacije naloga — evo kako da otvaranje firme u Srbiji ostane predvidljivo.',
      },
      en: {
        title: 'Opening a company in Serbia: a practical checklist',
        metaTitle: 'Opening a Company in Serbia — Steps, Address & APR | Top14',
        metaDescription:
          'Company formation in Serbia: legal form, Belgrade business address, APR filings, VAT, and banking. A structured guide for founders and foreign investors.',
        excerpt:
          'From legal form to go‑live operations—keep Serbian company formation predictable with this checklist.',
      },
      ru: {
        title: 'Открытие фирмы в Сербии: практический чек-лист',
        metaTitle: 'Открытие фирмы в Сербии — шаги, адрес и APR | Top14',
        metaDescription:
          'Регистрация компании в Сербии: форма, адрес в Белграде, процедуры APR, НДС и банк. Структурированное руководство.',
        excerpt:
          'От выбора формы до запуска — как пройти регистрацию без сюрпризов.',
      },
      tr: {
        title: 'Sırbistan’da şirket kurulumu: uygulanabilir kontrol listesi',
        metaTitle: 'Sırbistan’da şirket kurulumu — adımlar, adres ve APR | Top14',
        metaDescription:
          'Şirket kurulumu: hukuki form, Belgrad iş adresi, APR, KDV ve banka. Kurucular ve yatırımcılar için yapılandırılmış rehber.',
        excerpt:
          'Hukuki formdan operasyona — süreci öngörülebilir tutun.',
      },
      de: {
        title: 'Firmengründung in Serbien: eine pragmatische Checkliste',
        metaTitle: 'Firmengründung in Serbien — Schritte, Adresse & APR | Top14',
        metaDescription:
          'Unternehmensgründung in Serbien: Rechtsform, Belgrader Geschäftsadresse, APR, USt und Bankkonto. Strukturierter Leitfaden.',
        excerpt:
          'Von der Rechtsform bis zum laufenden Betrieb – so bleibt die Gründung planbar.',
      },
    },
  },
  {
    slug: 'business-address-apr-rules',
    published: '2026-03-14',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['virtual-office-belgrade-why-it-matters', 'apr-registration-timeline-2026', 'opening-company-serbia-checklist'],
    externalRefs: [{ url: APR, label: { sr: 'APR', en: 'APR Serbia', ru: 'APR Сербия', tr: 'APR Sırbistan', de: 'APR Serbien' } }],
    translations: {
      sr: {
        title: 'Poslovna adresa i APR: šta virtuelna kancelarija mora da pokrije',
        metaTitle: 'Poslovna adresa, APR i virtuelna kancelarija Beograd | Top14',
        metaDescription:
          'Kako poslovna adresa ispunjava zahteve APR-a, šta znači sedište firme i kako virtuelna kancelarija u Beogradu ostaje usklađena sa zakonodavstvom.',
        excerpt:
          'Jasnoća oko sedišta i prijema pošte štedi vreme i sprečava administrativne probleme.',
      },
      en: {
        title: 'Business address & APR: what a virtual office must cover',
        metaTitle: 'Business Address, APR & Virtual Office Belgrade | Top14',
        metaDescription:
          'How a Serbian business address satisfies registry rules, what “seat” means, and how a Belgrade virtual office stays compliant.',
        excerpt:
          'Clarity on seat and mail handling prevents costly registry corrections.',
      },
      ru: {
        title: 'Деловой адрес и APR: что должен покрывать виртуальный офис',
        metaTitle: 'Деловой адрес, APR и виртуальный офис в Белграде | Top14',
        metaDescription:
          'Требования к юридическому адресу в Сербии и как виртуальный офис остаётся соответствующим правилам.',
        excerpt:
          'Чёткость по адресу и почте экономит время и деньги.',
      },
      tr: {
        title: 'İş adresi ve APR: sanal ofisin kapsaması gerekenler',
        metaTitle: 'İş adresi, APR ve Belgrad sanal ofisi | Top14',
        metaDescription:
          'Sırbistan’da sicil adresi kuralları ve sanal ofisin uyumu. Pratik açıklama.',
        excerpt:
          'Adres ve posta netliği düzeltme maliyetlerini azaltır.',
      },
      de: {
        title: 'Geschäftsadresse & APR: Das muss ein virtuelles Büro abdecken',
        metaTitle: 'Geschäftsadresse, APR & virtuelles Büro Belgrad | Top14',
        metaDescription:
          'Anforderungen an die Satzungsadresse in Serbien und Compliance eines Belgrader Virtual-Office-Anbieters.',
        excerpt:
          'Klarheit bei Sitz und Post vermeidet teure Nachträge.',
      },
    },
  },
  {
    slug: 'foreign-investors-belgrade-hub',
    published: '2026-03-20',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['opening-company-serbia-checklist', 'belgrade-prestige-address-brand', 'virtual-office-belgrade-why-it-matters'],
    externalRefs: [{ url: EU_BUS, label: { sr: 'EU vodič', en: 'EU business portal', ru: 'Портал EU', tr: 'EU portalı', de: 'EU-Portal' } }],
    translations: {
      sr: {
        title: 'Strani investitori i Beograd kao poslovni čvor',
        metaTitle: 'Strani investitori, kancelarija Beograd i virtuelna kancelarija | Top14',
        metaDescription:
          'Zašto investitori biraju poslovnu adresu u Beogradu, kako virtuelna kancelarija podržava timove u regionu i šta očekivati od administracije.',
        excerpt: 'Beograd kao most ka tržištu EU i regionu zahteva jasnu adresu i operativnu podršku.',
      },
      en: {
        title: 'Foreign investors and Belgrade as a regional hub',
        metaTitle: 'Foreign Investors, Belgrade Office & Virtual Office | Top14',
        metaDescription:
          'Why teams pick a Belgrade business address, how a virtual office supports regional operations, and what to plan for compliance.',
        excerpt: 'Belgrade works as a bridge to EU and regional markets—if your address and ops are aligned.',
      },
      ru: {
        title: 'Иностранные инвесторы и Белград как деловой узел',
        metaTitle: 'Инвесторы, офис в Белграде и виртуальный офис | Top14',
        metaDescription:
          'Почему выбирают адрес в Белграде и как виртуальный офис поддерживает региональные команды.',
        excerpt: 'Белград как мост к рынкам — при грамотной адресе и процессах.',
      },
      tr: {
        title: 'Yabancı yatırımcılar ve Belgrad merkezi',
        metaTitle: 'Yatırımcılar, Belgrad ofisi ve sanal ofis | Top14',
        metaDescription:
          'Belgrad iş adresinin avantajları ve bölgesel operasyonlarda sanal ofisin rolü.',
        excerpt: 'Doğru adres ve süreçlerle Belgrad köprü görevi görür.',
      },
      de: {
        title: 'Ausländische Investoren und Belgrad als Hub',
        metaTitle: 'Investoren, Belgrader Büro & virtuelles Büro | Top14',
        metaDescription:
          'Warum Teams eine Belgrader Geschäftsadresse wählen und wie ein virtuelles Büro regionale Operationen stützt.',
        excerpt: 'Belgrad als Brücke – mit klarer Adresse und Prozessen.',
      },
    },
  },
  {
    slug: 'mail-forwarding-virtual-office',
    published: '2026-03-25',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['business-address-apr-rules', 'virtual-office-roi-costs', 'virtual-office-belgrade-why-it-matters'],
    externalRefs: [{ url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } }],
    translations: {
      sr: {
        title: 'Prijem i prosleđivanje pošte uz virtuelnu kancelariju',
        metaTitle: 'Prijem pošte, virtuelna kancelarija i APR | Top14',
        metaDescription:
          'Kako funkcioniše prijem pošte uz virtuelnu kancelariju u Beogradu, zaštita podataka i brza obaveštenja klijentima.',
        excerpt: 'Digitalni tragovi i fizički prijem moraju biti usklađeni — evo šta tražiti.',
      },
      en: {
        title: 'Mail forwarding with a virtual office: what good looks like',
        metaTitle: 'Mail Receipt & Virtual Office Belgrade | Top14',
        metaDescription:
          'How mail intake works with a virtual office, data handling, and quick notifications to your team.',
        excerpt: 'Digital trails and physical handling must align—here is what to ask for.',
      },
      ru: {
        title: 'Пересылка почты при виртуальном офисе',
        metaTitle: 'Приём почты и виртуальный офис в Белграде | Top14',
        metaDescription:
          'Как организован приём почты, уведомления и защита данных при виртуальном офисе.',
        excerpt: 'Цифровой след и физическая обработка должны совпадать.',
      },
      tr: {
        title: 'Sanal ofisle posta yönetimi',
        metaTitle: 'Posta kabulü ve Belgrad sanal ofisi | Top14',
        metaDescription:
          'Posta alımı, bildirimler ve veri güvenliği — iyi uygulama özeti.',
        excerpt: 'Dijital iz ile fiziksel süreç uyumlu olmalı.',
      },
      de: {
        title: 'Postweiterleitung mit virtuellem Büro',
        metaTitle: 'Posteingang & virtuelles Büro Belgrad | Top14',
        metaDescription:
          'Wie Postprozesse funktionieren, Benachrichtigungen und Datenschutz beim Virtual Office.',
        excerpt: 'Digitale Spur und physische Bearbeitung müssen zusammenpassen.',
      },
    },
  },
  {
    slug: 'entrepreneur-pausal-vs-doo-address',
    published: '2026-03-28',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['opening-company-serbia-checklist', 'virtual-office-roi-costs', 'business-address-apr-rules'],
    externalRefs: [{ url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } }],
    translations: {
      sr: {
        title: 'Preduzetnik, pausal i adresa: kada virtuelna kancelarija ima smisla',
        metaTitle: 'Pausal, preduzetnik i virtuelna kancelarija Beograd | Top14',
        metaDescription:
          'Kratak pregled odnosa između poreske kategorije i poslovne adrese — bez pravnog saveta, ali sa praktičnim smernicama.',
        excerpt: 'Poreska kategorija i adresa moraju biti usklađene sa modelom poslovanja.',
      },
      en: {
        title: 'Entrepreneurs, flat‑rate tax, and when a virtual office fits',
        metaTitle: 'Flat‑rate entrepreneurs & virtual office Belgrade | Top14',
        metaDescription:
          'How business address choices interact with simplified tax regimes—practical pointers, not legal advice.',
        excerpt: 'Tax category and address should match how you really operate.',
      },
      ru: {
        title: 'Предприниматель, паушал и адрес: когда нужен виртуальный офис',
        metaTitle: 'Паушал, предприниматель и виртуальный офис | Top14',
        metaDescription:
          'Практические ориентиры по адресу и налоговому режиму — не юридическая консультация.',
        excerpt: 'Режим и адрес должны соответствовать реальной работе.',
      },
      tr: {
        title: 'Girişimci, basit vergi ve sanal ofis',
        metaTitle: 'Basit vergi ve Belgrad sanal ofisi | Top14',
        metaDescription:
          'Adres seçimleri ve vergi kategorileri — pratik notlar.',
        excerpt: 'Kategori ve adres ile fiili operasyon uyumlu olmalı.',
      },
      de: {
        title: 'Einzelunternehmer, Pauschalsteuer und virtuelles Büro',
        metaTitle: 'Pauschalsteuer & virtuelles Büro Belgrad | Top14',
        metaDescription:
          'Praxisnahe Hinweise zu Adresse und Steuerregime – keine Rechtsberatung.',
        excerpt: 'Regime und Adresse müssen zur Realität passen.',
      },
    },
  },
  {
    slug: 'coworking-or-virtual-office-decision',
    published: '2026-04-01',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['virtual-office-belgrade-why-it-matters', 'virtual-office-roi-costs', 'belgrade-prestige-address-brand'],
    externalRefs: [],
    translations: {
      sr: {
        title: 'Coworking ili virtuelna kancelarija: kako odabrati',
        metaTitle: 'Coworking vs virtuelna kancelarija Beograd | Top14',
        metaDescription:
          'Poređenje fiksnih troškova, fleksibilnosti i slike prema klijentima — praktičan okvir odluke.',
        excerpt: 'Nema univerzalnog odgovora — zavisi od tima, budžeta i klijenta.',
      },
      en: {
        title: 'Coworking or virtual office: how to decide',
        metaTitle: 'Coworking vs Virtual Office Belgrade | Top14',
        metaDescription:
          'Compare fixed costs, flexibility, and client perception when choosing workspace in Serbia.',
        excerpt: 'No universal answer—depends on team size, budget, and client visits.',
      },
      ru: {
        title: 'Коворкинг или виртуальный офис: как выбрать',
        metaTitle: 'Коворкинг vs виртуальный офис Белград | Top14',
        metaDescription:
          'Сравнение затрат и гибкости при выборе формата работы в Сербии.',
        excerpt: 'Зависит от команды, бюджета и визитов клиентов.',
      },
      tr: {
        title: 'Coworking mi sanal ofis mi: nasıl seçilir?',
        metaTitle: 'Coworking vs Belgrad sanal ofisi | Top14',
        metaDescription:
          'Maliyet, esneklik ve müteri algısı açısından karşılaştırma.',
        excerpt: 'Ekip, bütçe ve ziyaret sıklığına bağlı.',
      },
      de: {
        title: 'Coworking oder virtuelles Büro: Entscheidungshilfe',
        metaTitle: 'Coworking vs virtuelles Büro Belgrad | Top14',
        metaDescription:
          'Kosten, Flexibilität und Kundenwahrnehmung im Vergleich.',
        excerpt: 'Hängt von Team, Budget und Besuchsfrequenz ab.',
      },
    },
  },
  {
    slug: 'belgrade-prestige-address-brand',
    published: '2026-04-02',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['foreign-investors-belgrade-hub', 'virtual-office-belgrade-why-it-matters', 'business-address-apr-rules'],
    externalRefs: [],
    translations: {
      sr: {
        title: 'Kancelarija Beograd i percepcija brenda na srpskom tržištu',
        metaTitle: 'Kancelarija Beograd — reputacija i virtuelna kancelarija | Top14',
        metaDescription:
          'Kako lokacija poslovne adrese utiče na poverenje partnera i kako virtuelna kancelarija na centralnoj adresi podržava brend.',
        excerpt: 'Adresa je deo prvog utiska — posebno u B2B odnosima.',
      },
      en: {
        title: 'Belgrade office location and brand perception',
        metaTitle: 'Belgrade Business Address & Brand Trust | Top14',
        metaDescription:
          'Why a recognizable Belgrade address matters in B2B and how virtual offices support brand presence.',
        excerpt: 'Your address is part of the first impression—especially in B2B.',
      },
      ru: {
        title: 'Адрес в Белграде и восприятие бренда',
        metaTitle: 'Белград, деловой адрес и бренд | Top14',
        metaDescription:
          'Почему узнаваемый адрес важен в B2B и как виртуальный офис усиливает присутствие.',
        excerpt: 'Адрес — часть первого впечатления.',
      },
      tr: {
        title: 'Belgrad ofis konumu ve marka algısı',
        metaTitle: 'Belgrad iş adresi ve güven | Top14',
        metaDescription:
          'Tanınmış bir adresin B2B’deki rolü ve sanal ofisin marka desteği.',
        excerpt: 'Adres ilk izlenimin parçasıdır.',
      },
      de: {
        title: 'Belgrader Lage und Markenwahrnehmung',
        metaTitle: 'Belgrader Geschäftsadresse & Vertrauen | Top14',
        metaDescription:
          'Warum eine bekannte Adresse in B2B zählt und virtuelle Büros die Präsenz stützen.',
        excerpt: 'Die Adresse ist Teil des ersten Eindrucks.',
      },
    },
  },
  {
    slug: 'apr-registration-timeline-2026',
    published: '2026-04-04',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['opening-company-serbia-checklist', 'business-address-apr-rules', 'foreign-investors-belgrade-hub'],
    externalRefs: [{ url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } }],
    translations: {
      sr: {
        title: 'APR registracija: realna vremenska očekivanja u 2026.',
        metaTitle: 'APR registracija i otvaranje firme — vremenski okvir | Top14',
        metaDescription:
          'Koji koraci određuju trajanje registracije, uloga poslovne adrese i kako smanjiti zastoje uz pripremu dokumenata.',
        excerpt: 'Dokumenti i adresa spremni unapred skraćuju put do rešenja.',
      },
      en: {
        title: 'APR registration timeline: what to expect in 2026',
        metaTitle: 'APR Registration & Company Formation Timeline | Top14',
        metaDescription:
          'What drives registry speed, how your business address affects filings, and how to avoid rework.',
        excerpt: 'Prepared documents and a ready address shorten the path to resolution.',
      },
      ru: {
        title: 'Сроки регистрации в APR: ожидания в 2026 году',
        metaTitle: 'Регистрация APR и сроки | Top14',
        metaDescription:
          'Что влияет на скорость и как адрес и документы сокращают задержки.',
        excerpt: 'Готовые документы ускоряют решение.',
      },
      tr: {
        title: 'APR tescil süreleri: 2026 beklentileri',
        metaTitle: 'APR tescili ve süre çerçevesi | Top14',
        metaDescription:
          'Süreyi etkileyen faktörler ve belgelerin hazırlanması.',
        excerpt: 'Hazır belgeler ve adres gecikmeyi azaltır.',
      },
      de: {
        title: 'APR-Registrierung: Zeiterwartungen 2026',
        metaTitle: 'APR-Registrierung & Zeitplan | Top14',
        metaDescription:
          'Was die Dauer beeinflusst und wie vorbereitete Unterlagen helfen.',
        excerpt: 'Vorbereitete Dokumente verkürzen die Bearbeitung.',
      },
    },
  },
  {
    slug: 'virtual-office-roi-costs',
    published: '2026-04-06',
    modified: '2026-04-01',
    readMinutes: 12,
    relatedSlugs: ['coworking-or-virtual-office-decision', 'mail-forwarding-virtual-office', 'virtual-office-belgrade-why-it-matters'],
    externalRefs: [],
    translations: {
      sr: {
        title: 'Troškovi virtuelne kancelarije i povrat investicije',
        metaTitle: 'Troškovi virtuelne kancelarije Beograd i ROI | Top14',
        metaDescription:
          'Kako porediti fiksne mesečne troškove sa zakupom kancelarije, šta uključiti u budžet i kako meriti vrednost podrške.',
        excerpt: 'ROI nije samo cena po kvadratu — vreme tima je skuplje od paketa.',
      },
      en: {
        title: 'Virtual office costs and ROI: a practical view',
        metaTitle: 'Virtual Office Costs Belgrade & ROI | Top14',
        metaDescription:
          'Compare monthly fees to traditional leases, what to budget beyond rent, and how to value support time saved.',
        excerpt: 'ROI is not only price per square meter—team time matters more.',
      },
      ru: {
        title: 'Стоимость виртуального офиса и окупаемость',
        metaTitle: 'Стоимость виртуального офиса Белград и ROI | Top14',
        metaDescription:
          'Сравнение с арендой, что включать в бюджет и ценность поддержки.',
        excerpt: 'ROI — не только цена за метр; время команды дороже.',
      },
      tr: {
        title: 'Sanal ofis maliyetleri ve geri dönüş',
        metaTitle: 'Sanal ofis maliyetleri Belgrad ve ROI | Top14',
        metaDescription:
          'Kiralama ile karşılaştırma, bütçe kalemleri ve zaman tasarrufunun değeri.',
        excerpt: 'ROI yalnızca metrekare fiyatı değildir.',
      },
      de: {
        title: 'Kosten und ROI eines virtuelles Büros',
        metaTitle: 'Virtuelles Büro Kosten Belgrad & ROI | Top14',
        metaDescription:
          'Vergleich zur Miete, Budgetposten und Wert gesparter Zeit.',
        excerpt: 'ROI ist nicht nur Quadratmeterpreis.',
      },
    },
  },
  {
    slug: 'virtual-office-foreigner-apr-without-residence',
    published: '2026-04-08',
    modified: '2026-04-23',
    readMinutes: 12,
    relatedSlugs: [
      'virtual-office-privacy-public-person-apr',
      'virtual-office-travel-flat-rate-mail',
      'foreign-investors-belgrade-hub',
      'business-address-apr-rules',
      'opening-company-serbia-checklist',
    ],
    externalRefs: [
      { url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } },
      { url: EU_BUS, label: { sr: 'EU vodič', en: 'EU business portal', ru: 'Портал EU', tr: 'EU portalı', de: 'EU-Portal' } },
    ],
    translations: {
      sr: {
        title: 'Stranac bez boravka u Srbiji: kada stanodavac ne dozvoljava sedište na adresi najma',
        metaTitle: 'Stranac, najam i APR — virtuelna kancelarija Beograd | Top14',
        metaDescription:
          'Zašto strani državljanin često ne može da prijavi firmu na adresi stana, šta znači odbijanje saglasnosti vlasnika i kako virtuelna kancelarija u Beogradu rešava sedište uz APR.',
        excerpt:
          'Najam nije ista stvar kao vlasništvo: bez saglasnosti za poslovnu adresu, registracija na tom mestu često nije moguća — a posao ipak mora imati sedište.',
      },
      en: {
        title: 'Foreign nationals without Serbian residency: when your landlord blocks the registered seat',
        metaTitle: 'Foreign Founder, Lease & APR Address — Virtual Office Belgrade | Top14',
        metaDescription:
          'Why a rental address often cannot serve as a Serbian business seat without the owner’s consent, and how a Belgrade virtual office keeps APR registration workable.',
        excerpt:
          'A lease is not ownership—without consent for business use of the address, founders often need a separate registered seat.',
      },
      ru: {
        title: 'Иностранец без ВНЖ: когда арендодатель не согласен на юр. адрес в квартире',
        metaTitle: 'Иностранный основатель, аренда и адрес APR | Top14',
        metaDescription:
          'Почему адрес арендованной квартиры часто нельзя использовать как юридический без согласия собственника и как виртуальный офис в Белграде закрывает вопрос с APR.',
        excerpt:
          'Аренда не равна праву использовать адрес как официальное место регистрации бизнеса.',
      },
      tr: {
        title: 'Sırbistan’da ikamet olmadan yabancı girişimci: ev sahibi adresi engellediğinde',
        metaTitle: 'Yabancı kurucu, kira ve APR adresi — Belgrad sanal ofis | Top14',
        metaDescription:
          'Kira sözleşmesinde iş adresi izni yoksa ne olur ve Belgrad sanal ofisi kayıtlı merkezi nasıl sürdürülebilir kılar?',
        excerpt:
          'Kira, işletme kayıt adresi iznini otomatik vermez; ayrı bir merkez adresi gerekir.',
      },
      de: {
        title: 'Ausländer ohne Aufenthalt: wenn der Vermieter den Geschäftssitz verweigert',
        metaTitle: 'Gründer, Miete & APR-Sitz — virtuelles Büro Belgrad | Top14',
        metaDescription:
          'Warum eine Mietwohnung oft nicht ohne Zustimmung als Satzungsadresse genutzt werden kann und wie ein Virtual Office in Belgrad den APR-Prozess unterstützt.',
        excerpt:
          'Miete ersetzt keine Zustimmung zur Nutzung als Firmensitz.',
      },
    },
  },
  {
    slug: 'virtual-office-privacy-public-person-apr',
    published: '2026-04-10',
    modified: '2026-04-23',
    readMinutes: 12,
    relatedSlugs: [
      'virtual-office-foreigner-apr-without-residence',
      'virtual-office-travel-flat-rate-mail',
      'belgrade-prestige-address-brand',
      'business-address-apr-rules',
      'mail-forwarding-virtual-office',
    ],
    externalRefs: [{ url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } }],
    translations: {
      sr: {
        title: 'Javna ličnost i preduzetnica: zašto kućna adresa na APR-u može biti problem',
        metaTitle: 'Privatnost, APR i virtuelna kancelarija — mediji, brend | Top14',
        metaDescription:
          'Kada je kućna adresa javno vidljiva u registru rizik po privatnost i bezbednost; kako virtuelna kancelarija odvaja dom od sedišta firme.',
        excerpt:
          'Za nekoga ko se javno eksponira, adresa stana na APR-u nije samo formalnost — to je i mapa do vašeg privatnog života.',
      },
      en: {
        title: 'Public-facing entrepreneurs: why a home address in the registry can be a privacy risk',
        metaTitle: 'Privacy, APR & Virtual Office for Creators and SMEs | Top14',
        metaDescription:
          'Media, creators, and visible founders: separating your home from the registered seat, mail handling, and a professional Belgrade business address.',
        excerpt:
          'A public registry address is not “just paperwork” when your work makes you easy to find.',
      },
      ru: {
        title: 'Предприниматель и публичность: домашний адрес в APR и риски',
        metaTitle: 'Конфиденциальность, APR и виртуальный офис для медиа | Top14',
        metaDescription:
          'Почему домашний адрес в открытом реестре — вопрос приватности и безопасности и как виртуальный офис отделяет личное от юр. адреса.',
        excerpt:
          'Если вас легко найти онлайн, публичный адрес проживания в реестре усиливает риски.',
      },
      tr: {
        title: 'Medya ve görünür girişimciler: APR’de ev adresi neden riskli?',
        metaTitle: 'Gizlilik, APR ve sanal ofis — içerik üreticileri | Top14',
        metaDescription:
          'Kayıtlarda görünen ev adresi mahremiyet ve güvenlik açısından sorun olabilir; Belgrad iş adresi ve posta süreçleri.',
        excerpt:
          'Herkese açık profille çalışanlar için ev adresi yalnızca bir satır değildir.',
      },
      de: {
        title: 'Öffentlich sichtbare Gründer: Wenn die Wohnadresse im Handelsregister problematisch wird',
        metaTitle: 'Datenschutz, APR & virtuelles Büro für Kreative | Top14',
        metaDescription:
          'Medien, Creator und sichtbare Selbstständige: Trennung von Privatadresse und Satzungsadresse sowie zuverlässiger Posteingang.',
        excerpt:
          'Ein öffentlicher Wohnsitz in Registern ist mehr als Formalität.',
      },
    },
  },
  {
    slug: 'capitaale-pausal-invoicing-tool',
    published: '2026-07-21',
    modified: '2026-07-21',
    readMinutes: 8,
    relatedSlugs: [
      'entrepreneur-pausal-vs-doo-address',
      'virtual-office-roi-costs',
      'virtual-office-travel-flat-rate-mail',
    ],
    externalRefs: [
      { url: PURS, label: { sr: 'Poreska uprava', en: 'Serbian Tax Administration', ru: 'Налоговая Сербии', tr: 'Sırp Vergi İdaresi', de: 'Serbische Steuerverwaltung' } },
      { url: NBS, label: { sr: 'NBS — kursna lista', en: 'NBS exchange rates', ru: 'НБС — курсы валют', tr: 'NBS döviz kurları', de: 'NBS-Wechselkurse' } },
    ],
    translations: {
      sr: {
        title: 'Capitaale: alat za paušalce koji naplaćuju iz inostranstva',
        metaTitle: 'Capitaale — paušalni limit, kurs i fakturisanje za preduzetnike | Top14',
        metaDescription:
          'Kako Capitaale pomaže paušalcima da prate šestomilionski limit, kurs banke i test samostalnosti, i kako se uklapa uz virtuelnu kancelariju.',
        excerpt:
          'Paušalni limit, kurs banke, 70% test i faktura za 60 sekundi — sve u jednoj aplikaciji za preduzetnike koji naplaćuju iz inostranstva.',
      },
      en: {
        title: 'Capitaale: a tool for flat-tax entrepreneurs who invoice abroad',
        metaTitle: 'Capitaale — flat-tax limit, bank rate and invoicing for entrepreneurs | Top14',
        metaDescription:
          'How Capitaale helps flat-rate entrepreneurs track the six-million limit, real bank rates, the 70% independence test, and invoice in EUR or USD in 60 seconds.',
        excerpt:
          'Live flat-tax limit, real bank rate, the 70% independence test, and an invoice in 60 seconds—everything in one app for founders who bill abroad.',
      },
      ru: {
        title: 'Capitaale: инструмент для паушалщиков, выставляющих счета из-за рубежа',
        metaTitle: 'Capitaale — паушальный лимит, банковский курс и счета | Top14',
        metaDescription:
          'Как Capitaale помогает отслеживать шестимиллионный лимит, банковский курс и тест на самостоятельность, и как сочетается с виртуальным офисом.',
        excerpt:
          'Лимит в реальном времени, банковский курс, тест 70% и счёт за 60 секунд — всё в одном приложении.',
      },
      tr: {
        title: 'Capitaale: yurt dışından fatura kesen pauschal girişimciler için araç',
        metaTitle: 'Capitaale — pauschal limiti, banka kuru ve faturalama | Top14',
        metaDescription:
          'Capitaale\'in altı milyon limiti, banka kurunu ve %70 bağımsızlık testini takip etmeye nasıl yardımcı olduğunu ve sanal ofisle nasıl uyum sağladığını keşfedin.',
        excerpt:
          'Canlı pauschal limiti, gerçek banka kuru, %70 testi ve 60 saniyede fatura — yurt dışından fatura kesen girişimciler için tek uygulama.',
      },
      de: {
        title: 'Capitaale: ein Tool für Pauschalunternehmer, die aus dem Ausland fakturieren',
        metaTitle: 'Capitaale — Pauschalsteuer-Limit, Bankkurs und Rechnungsstellung | Top14',
        metaDescription:
          'Wie Capitaale Pauschalunternehmern hilft, das Sechs-Millionen-Limit, den Bankkurs und den 70-%-Unabhängigkeitstest zu verfolgen.',
        excerpt:
          'Live-Limit, realer Bankkurs, 70-%-Test und eine Rechnung in 60 Sekunden – alles in einer App für Gründer, die im Ausland fakturieren.',
      },
    },
  },
  {
    slug: 'belgrade-vs-kovin-pausal-address',
    published: '2026-07-24',
    modified: '2026-07-26',
    readMinutes: 9,
    relatedSlugs: [
      'entrepreneur-pausal-vs-doo-address',
      'business-address-apr-rules',
      'belgrade-prestige-address-brand',
      'capitaale-pausal-invoicing-tool',
    ],
    externalRefs: [
      { url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } },
      { url: PURS, label: { sr: 'Poreska uprava', en: 'Serbian Tax Administration', ru: 'Налоговая Сербии', tr: 'Sırp Vergi İdaresi', de: 'Serbische Steuerverwaltung' } },
    ],
    translations: {
      sr: {
        title: 'Beograd ili Kovin: kako paušalac bira poslovnu adresu',
        metaTitle: 'Beograd vs Kovin za paušal - poslovna adresa i virtuelna kancelarija | Top14',
        metaDescription:
          'Kada paušalac bira sedište u Beogradu ili Kovinu (PU Pančevo): reputacija, pošta, poreski kontekst i šta virtuelna kancelarija stvarno pokriva.',
        excerpt:
          'Beograd daje reputaciju i logistiku. Kovin često ide uz paušal i trošak. Izbor zavisi od modela rada, ne od slogana.',
      },
      en: {
        title: 'Belgrade or Kovin: how flat-tax entrepreneurs choose a business address',
        metaTitle: 'Belgrade vs Kovin for flat-tax - business address and virtual office | Top14',
        metaDescription:
          'How to choose between a Belgrade seat and Kovin (Pančevo tax office): reputation, mail, tax context, and what a virtual office really covers.',
        excerpt:
          'Belgrade supports reputation and logistics. Kovin often fits flat-tax and cost focus. The choice follows your operating model, not a slogan.',
      },
      ru: {
        title: 'Белград или Ковин: как паушалщик выбирает деловой адрес',
        metaTitle: 'Белград vs Ковин для паушала - деловой адрес и виртуальный офис | Top14',
        metaDescription:
          'Когда выбирать Белград или Ковин (налоговая Панчево): репутация, почта, налоговый контекст и что реально даёт виртуальный офис.',
        excerpt:
          'Белград усиливает репутацию и логистику. Ковин чаще подходит под паушал и экономию. Выбор зависит от модели работы.',
      },
      tr: {
        title: 'Belgrad veya Kovin: pauschal girişimci iş adresini nasıl seçer',
        metaTitle: 'Pauschal için Belgrad vs Kovin - iş adresi ve sanal ofis | Top14',
        metaDescription:
          'Belgrad merkezi ile Kovin (Pančevo vergi dairesi) arasında seçim: itibar, posta, vergi bağlamı ve sanal ofisin gerçekten ne sağladığı.',
        excerpt:
          'Belgrad itibar ve lojistik sağlar. Kovin çoğu zaman pauschal ve maliyet odaklıdır. Seçim slogan değil, iş modelinize bağlıdır.',
      },
      de: {
        title: 'Belgrad oder Kovin: so wählen Pauschalunternehmer die Geschäftsadresse',
        metaTitle: 'Belgrad vs Kovin für Pauschal - Geschäftsadresse und Virtual Office | Top14',
        metaDescription:
          'Wann Belgrad und wann Kovin (Finanzamt Pančevo): Ruf, Post, Steuerkontext und was ein Virtual Office wirklich abdeckt.',
        excerpt:
          'Belgrad stützt Ruf und Logistik. Kovin passt oft zu Pauschale und Kostenfokus. Die Wahl folgt dem Betriebsmodell, nicht dem Slogan.',
      },
    },
  },
  {
    slug: 'serbia-company-bank-account-after-registration',
    published: '2026-07-25',
    modified: '2026-07-26',
    readMinutes: 9,
    relatedSlugs: [
      'opening-company-serbia-checklist',
      'business-address-apr-rules',
      'virtual-office-foreigner-apr-without-residence',
      'mail-forwarding-virtual-office',
    ],
    externalRefs: [
      { url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } },
      { url: NBS, label: { sr: 'NBS', en: 'NBS', ru: 'НБС', tr: 'NBS', de: 'NBS' } },
    ],
    translations: {
      sr: {
        title: 'Poslovni račun u Srbiji posle registracije firme',
        metaTitle: 'Otvaranje poslovnog računa posle APR registracije | Top14',
        metaDescription:
          'Redosled posle otvaranja firme: dokumentacija, sedište, šta banke traže i gde virtuelna kancelarija pomaže pri onboarding-u.',
        excerpt:
          'Prvo uredno sedište i papiri, pa banka. Virtuelna kancelarija ne otvara račun umesto vas, ali često uklanja zastoj oko adrese i pošte.',
      },
      en: {
        title: 'A Serbian business bank account after company registration',
        metaTitle: 'Opening a business account after APR registration | Top14',
        metaDescription:
          'What to do after company formation: documents, registered seat, what banks usually ask for, and where a virtual office helps onboarding.',
        excerpt:
          'Fix the seat and paperwork first, then the bank. A virtual office does not open the account for you, but it often removes address and mail friction.',
      },
      ru: {
        title: 'Расчётный счёт в Сербии после регистрации компании',
        metaTitle: 'Открытие счёта после регистрации в APR | Top14',
        metaDescription:
          'Порядок после регистрации: документы, юр. адрес, что обычно просят банки и где помогает виртуальный офис.',
        excerpt:
          'Сначала адрес и документы, потом банк. Виртуальный офис не открывает счёт за вас, но часто снимает затык с адресом и почтой.',
      },
      tr: {
        title: 'Şirket tescilinden sonra Sırbistan’da ticari banka hesabı',
        metaTitle: 'APR tescilinden sonra ticari hesap açılışı | Top14',
        metaDescription:
          'Kuruluş sonrası sıra: belgeler, merkez adresi, bankaların genelde istediği evraklar ve sanal ofisin onboarding’e katkısı.',
        excerpt:
          'Önce düzenli merkez ve evrak, sonra banka. Sanal ofis hesabı sizin yerinize açmaz; adres ve posta sürtünmesini sıkça azaltır.',
      },
      de: {
        title: 'Geschäftskonto in Serbien nach der Firmenregistrierung',
        metaTitle: 'Geschäftskonto nach APR-Registrierung eröffnen | Top14',
        metaDescription:
          'Ablauf nach der Gründung: Unterlagen, Sitz, was Banken meist verlangen und wo ein Virtual Office beim Onboarding hilft.',
        excerpt:
          'Zuerst Sitz und Unterlagen, dann die Bank. Ein Virtual Office eröffnet kein Konto für Sie, beseitigt aber oft Adress- und Postreibung.',
      },
    },
  },
  {
    slug: 'change-registered-seat-apr-guide',
    published: '2026-07-26',
    modified: '2026-07-26',
    readMinutes: 9,
    relatedSlugs: [
      'business-address-apr-rules',
      'belgrade-vs-kovin-pausal-address',
      'virtual-office-privacy-public-person-apr',
      'apr-registration-timeline-2026',
    ],
    externalRefs: [
      { url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } },
      { url: EUPRAVA, label: { sr: 'eUprava', en: 'eGovernment Serbia', ru: 'eUprava', tr: 'eUprava', de: 'eUprava' } },
    ],
    translations: {
      sr: {
        title: 'Promena sedišta u APR-u: kada i kako se radi',
        metaTitle: 'Promena poslovne adrese u APR-u - vodič | Top14',
        metaDescription:
          'Kada menjati sedište firme, koja dokumentacija treba, redosled koraka i uloga dozvole za adresu kod virtuelne kancelarije.',
        excerpt:
          'Prvo saglasnost za novu adresu, pa APR. Virtuelna kancelarija daje dozvolu, dokumenta i prijem pošte, a podnesak i dalje vodite uz svoje savetnike.',
      },
      en: {
        title: 'Changing your registered seat in the APR: when and how',
        metaTitle: 'Change of business address in the APR - guide | Top14',
        metaDescription:
          'When to change a company seat, which documents you need, the practical sequence, and the role of address consent with a virtual office.',
        excerpt:
          'Get consent for the new address first, then file with the APR. A virtual office provides consent, documents and mail intake while you keep control of the filing.',
      },
      ru: {
        title: 'Смена юридического адреса в APR: когда и как',
        metaTitle: 'Смена делового адреса в APR - гайд | Top14',
        metaDescription:
          'Когда менять юр. адрес, какие документы нужны, порядок шагов и роль согласия на адрес при виртуальном офисе.',
        excerpt:
          'Сначала согласие на новый адрес, потом APR. Виртуальный офис даёт разрешение, документы и приём почты; подачу вы ведёте со своими консультантами.',
      },
      tr: {
        title: 'APR’de kayıtlı merkez değişikliği: ne zaman ve nasıl',
        metaTitle: 'APR’de iş adresi değişikliği - rehber | Top14',
        metaDescription:
          'Merkez ne zaman değişir, hangi belgeler gerekir, adım sırası ve sanal ofiste adres izninin rolü.',
        excerpt:
          'Önce yeni adres için izin, sonra APR. Sanal ofis izin, belge ve posta kabulü sağlar; başvuruyu danışmanlarınızla siz yönetirsiniz.',
      },
      de: {
        title: 'Sitzänderung im APR: wann und wie',
        metaTitle: 'Änderung der Geschäftsadresse im APR - Leitfaden | Top14',
        metaDescription:
          'Wann den Firmensitz ändern, welche Unterlagen nötig sind, praktischer Ablauf und Rolle der Adresszustimmung beim Virtual Office.',
        excerpt:
          'Zuerst Zustimmung zur neuen Adresse, dann APR. Das Virtual Office liefert Zustimmung, Unterlagen und Postannahme; die Einreichung steuern Sie mit Ihren Beratern.',
      },
    },
  },
  {
    slug: 'virtual-office-travel-flat-rate-mail',
    published: '2026-04-12',
    modified: '2026-04-23',
    readMinutes: 12,
    relatedSlugs: [
      'virtual-office-foreigner-apr-without-residence',
      'virtual-office-privacy-public-person-apr',
      'entrepreneur-pausal-vs-doo-address',
      'mail-forwarding-virtual-office',
      'business-address-apr-rules',
    ],
    externalRefs: [
      { url: APR, label: { sr: 'APR', en: 'APR', ru: 'APR', tr: 'APR', de: 'APR' } },
    ],
    translations: {
      sr: {
        title: 'Česta putovanja i paušal: kako ostati uredan kada nemate „stalnu“ adresu u Srbiji',
        metaTitle: 'Paušal, putovanja i virtuelna kancelarija — prijem pošte | Top14',
        metaDescription:
          'Preduzetnik na paušalu bez fiksne lokacije: zašto je poslovna adresa i dalje ključna, kako se prikuplja dokumentacija i šta pokriva dobra virtuelna kancelarija.',
        excerpt:
          'Paušal ne znači da adresa i pošta mogu biti „gde se slučajno nađem“ — stabilan prijem drži status i mir.',
      },
      en: {
        title: 'Frequent travel and flat‑rate entrepreneurship: staying compliant without a fixed home base',
        metaTitle: 'Travel, Flat‑Tax Entrepreneurs & Virtual Office Mail | Top14',
        metaDescription:
          'If you are often abroad or between cities, a Belgrade virtual office can anchor your registered seat and keep official correspondence under control.',
        excerpt:
          'Simplified tax status still needs a workable address and reliable mail—not “wherever I am this week”.',
      },
      ru: {
        title: 'Постоянные поездки и паушал: порядок без фиксированного адреса',
        metaTitle: 'Паушал, поездки и виртуальный офис — почта и документы | Top14',
        metaDescription:
          'Если вы часто в разъездах, юридический адрес и приём корреспонденции остаются критичными; как виртуальный офис в Белграде помогает.',
        excerpt:
          'Упрощённый режим не отменяет потребность в устойчивом адресе и почте.',
      },
      tr: {
        title: 'Seyahat eden girişimci ve basit vergi: sabit adres olmadan düzen',
        metaTitle: 'Seyahat, basit vergi ve sanal ofis postası | Top14',
        metaDescription:
          'Sırbistan’da sürekli yolculuk varsa kayıtlı merkez ve resmi posta yönetimi neden kritik ve sanal ofis nasıl destekler?',
        excerpt:
          'Basit vergi rejimi, “bu hafta neredeysem orası” adresiyle yürümez.',
      },
      de: {
        title: 'Vielreisende Einzelunternehmer: Ordnung ohne festen Wohnsitz',
        metaTitle: 'Reisen, Pauschalsteuer & Post im Virtual Office | Top14',
        metaDescription:
          'Wenn Sie oft unterwegs sind, braucht der Betrieb dennoch einen belastbaren Sitz und zuverlässigen Posteingang—virtuelles Büro Belgrad als Anker.',
        excerpt:
          'Pauschalbesteuerung ersetzt keine funktionierende Adresse und Postlogistik.',
      },
    },
  },
];
